import { Controller } from "stimulus";
import { isPlayerActive } from "utils/player_activity";

export default class extends Controller {
  static values = { itemId: Number, itemType: String };

  async add(event) {
    // Prevent the parent card <a> from navigating when interacting with the queue button.
    event.preventDefault();
    event.stopPropagation();

    // Queueing is only useful once something is actually playing (the fixed player is up); if
    // nothing is playing yet, the user almost certainly wants to play this episode instead.
    const playButton = this.findPlayButtonController();
    if (!isPlayerActive() && playButton) {
      playButton.playNow({ userInitiated: true });
      return;
    }

    // The server derives everything else from the episode; queue_client dispatches
    // supercast-queue-changed with the resulting snapshot.
    await window.queueClient.addToQueue({ itemId: this.itemIdValue, itemType: this.itemTypeValue });

    window.showToast("Added to queue");
  }

  findPlayButtonController() {
    const group = this.element.closest("[data-episode-playback-group]");
    const el = group?.querySelector('[data-controller*="play-button"]');
    if (!el) return null;

    return (
      this.application.getControllerForElementAndIdentifier(el, "play-button") ||
      this.application.getControllerForElementAndIdentifier(el, "bridge--play-button")
    );
  }
}
